/* eslint-disable no-useless-catch */
import api from "shared/api";
import { OrganisationRaw } from "./models";
import { PrivatePersonRaw } from "./models/privatePerson";
import { FileEntryRaw } from "./models/fileEntry";

const prefix = "api/relationprofile";

export const getOrganisationForCurrentUser =
  async (): Promise<OrganisationRaw> => {
    try {
      const res = await api().get<OrganisationRaw>(`${prefix}/me/organisation`);
      return res.data;
    } catch (e) {
      throw e;
    }
  };

export const getPrivatePersonForCurrentUser =
  async (): Promise<PrivatePersonRaw> => {
    try {
      const res = await api().get<PrivatePersonRaw>(
        `${prefix}/me/private-person`
      );
      return res.data;
    } catch (e) {
      throw e;
    }
  };

export const getFileEntries = async (): Promise<FileEntryRaw[]> => {
  try {
    const res = await api().get<FileEntryRaw[]>(`${prefix}/me/archive`);
    return res.data;
  } catch (e) {
    throw e;
  }
};

export const getFrontendConfig = async (): Promise<{
  archive_enable: boolean;
  archive_show_project_files: boolean;
}> => {
  const res = await api().get<{
    archive_enable: boolean;
    archive_show_project_files: boolean;
  }>(`${prefix}/frontend-config`);
  return res.data;
};
